import styled from "styled-components";

const StyledTitle = styled.h1`
    font-size: 24px;
    font-weight: 700;
    color: #1e1e1e;
    margin: 0;
`;

const StyledSubTitle = styled.h2`
    font-size: 17px;
    font-weight: 400;
    color: #1e1e1e;
`;

const StyledUploadDiv = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    margin-bottom: 30px;
`;

const StyledUploadTitle = styled.h3`
    font-size: 15px;
    font-weight: 600;
    color: #1e1e1e;
`;

const StyledUploadInfo = styled.p`
    color: #787878;
    font-size: 13px;
    font-weight: 400;
    margin: 0;
`;

const StyledUploadBtn = styled.button`
    background: #fff;
    border: none;
    border-radius: 8px;
    padding: 8px 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    color: #787878;
    font-size: 15px;
    font-weight: 400;
    margin: 5px 0;
`;

const StyledUploadSpan = styled.span`
    font-size: 15px;
    color: #404040;
`;

const StyledUploadWarning = styled.p`
    color: #68717a;
    font-size: 13px;
    margin: 16px 0 0 0;
`;

export {
    StyledTitle,
    StyledSubTitle,
    StyledUploadDiv,
    StyledUploadTitle,
    StyledUploadInfo,
    StyledUploadBtn,
    StyledUploadSpan,
    StyledUploadWarning,
};
